export default __webpack_public_path__ + "static/media/FitnessTitle.adced8c0.svg";